"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cyrb53 = exports.stableStringify = void 0;
function stableStringify(obj) {
    if (obj instanceof Array)
        return '[' + obj.map(stableStringify).join(',') + ']';
    else if (typeof obj === 'object') {
        let keys = Object.keys(obj).sort();
        let str = '{';
        for (let key of keys)
            str += JSON.stringify(key) + ':' + stableStringify(obj[key]);
        return str + '}';
    }
    else
        return JSON.stringify(obj);
}
exports.stableStringify = stableStringify;
// From https://stackoverflow.com/a/52171480
function cyrb53(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
exports.cyrb53 = cyrb53;
function objectHash(obj) {
    let str = stableStringify(obj);
    return cyrb53(str);
}
exports.default = objectHash;
